module.exports = __webpack_public_path__ + "static/registerBermudaRu.3ecd514a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/templates/assets/registerBermudaRu.gif
// module id = 1002
// module chunks = 101932004231744